import { render, staticRenderFns } from "./ArchiveListItem.vue?vue&type=template&id=c2dd95a8&"
import script from "./ArchiveListItem.vue?vue&type=script&lang=js&"
export * from "./ArchiveListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports